export default __webpack_public_path__ + "static/media/bloons-logo.f8cbae3a.png";